/*!
* Copyright (c) 2018-present Cyclope.ai
* LICENSE file is in the root directory of this source tree.
* */
import * as ModelsFromStore  from '@apps-store/models';
import * as EnumsFromStore from '@apps-store/enums';
import { Dispatch } from 'redux';

import * as Utils from '@root-utils/index';

/**
 * @function DeconnexionActionSuccess  - 
 * @return { object } payload
 * @returns { string }  type
 * @param { any } 
 */
export function DeconnexionActionSuccess(data:any): ModelsFromStore.DeconnexionActionSuccess {

    return {
        
        payload:{

            data,
            loading: false,
            

        },

        type :EnumsFromStore.DeconnexionTypes.DECONNEXION_SUCCESS

    }
}

/**
 * @function DeconnexionActionFail  - 
 * @return { object }   payload
 * @returns { string }  type
 * @param { any } 
 */
export function DeconnexionActionFail(errors: any): ModelsFromStore.DeconnexionActionFail {

    return {
        payload:{

            error: errors  ,
            loading: false,
            
        },

        type :EnumsFromStore.DeconnexionTypes.DECONNEXION_FAIL

    }
}
/**
 * @function DeconnexionActionInProgress  - 
 * @return { object }   payload
 * @returns { string }  type
 * @param {  } 
 */
export function DeconnexionActionInProgress(): ModelsFromStore.DeconnexionActionInProgress{

    return {
        payload:{

         
            loading: true,
            
        },

        type :EnumsFromStore.DeconnexionTypes.DECONNEXION_INPROGRESS

    }
}


// CREATOR

/**
 * @function DeconnexionActionCreator
 * @param {  } 
 * @return {Promise<any>}  Promise
 */
export function DeconnexionActionCreator():(dispatch: Dispatch<any>, {}) => Promise<void>{
 
    return async (dispatch: Dispatch<any>) => {

        dispatch(DeconnexionActionInProgress());

        try {
            dispatch(DeconnexionActionSuccess("la déconnexion a reussi")); 
            Utils.localStorageClear()

        } catch (error) {
            dispatch(DeconnexionActionFail(error)); 
        }
    }
}


// WEBPACK FOOTER //
// ./src/apps/store/action-creator/logout/index.ts